import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchProductMappings } from '../actions/productMappingActions'

const useFetchingProductMappings = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchProductMappings())
  }, [dispatch])
}

export default useFetchingProductMappings
